import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-inline-spinner',
    templateUrl: './inline-spinner.component.html',
    styleUrls: ['./inline-spinner.component.css'],
    standalone: false
})
export class InlineSpinnerComponent {
  @Input() height: number;
  @Input() width: number;
}
